import React, { createContext, useState, useCallback } from "react";

export const KMSessionContext = createContext();

export const KMSessionProvider = ({ children }) => {
  const [sessionHistory, setSessionHistory] = useState([]);

  const updateSessionHistory = useCallback((newHistory) => {
    setSessionHistory(newHistory);
  }, []);

  const addNewSession = useCallback((newSession) => {
    setSessionHistory((prev) => [newSession, ...prev]);
  }, []);

  const value = {
    sessionHistory,
    setSessionHistory,
    updateSessionHistory,
    addNewSession,
  };

  return (
    <KMSessionContext.Provider value={value}>
      {children}
    </KMSessionContext.Provider>
  );
};
